import {
  SET_HIDDEN,
  FETCHED_PAIRS,
  FETCHED_MATCHED_PAIRS,
  FETCHED_ORDERS,
  FETCHED_DEMAND_OFFERS,
  FETCHED_SUB_DEMAND_OFFERS,
  FETCHED_MY_ORDERS,
  FETCHED_MATCHED_ORDERS,
  FETCHED_MY_MATCHED_ORDERS,
  FETCHED_PAST_ORDERS,
  FETCHED_MY_PAST_ORDERS,
  FETCHED_STATS,
  FETCHED_SUB_HISTORY,
  FETCHED_MY_UNMATCHED_ORDERS,
  REMOVE_WALLET
} from '../actions/types';
import {differenceWith} from 'ramda';
import M from 'materialize-css/dist/js/materialize.min.js'
import {pairs} from '../config';

let initialState =  {
  pairs,
  matched_pairs: pairs,

  firstCallDone: false,

  orders: [],
  matched_orders: [],

  offers: [],
  demand: [],

  sub_demand: [],
  sub_offers: [],

  my_orders: [],
  my_matched_orders: [],

  past_orders: [],
  my_past_orders: [],

  my_unmatched_orders:[],

  stats:{},
  sub_history: []
}

export default function(state: Object = initialState, action) {
  let data = action.payload;
  switch(action.type) {
    case FETCHED_PAIRS:
      return {...state, pairs: data}
    case FETCHED_MATCHED_PAIRS:
      return {...state, matched_pairs: data}
    case FETCHED_SUB_HISTORY:
      return {...state, sub_history: data}
    case FETCHED_STATS:
      return {...state, stats: data};
    case SET_HIDDEN:
      return {...state, hidden: data};
    case FETCHED_ORDERS:
      return { ...state, orders: data};
    case FETCHED_DEMAND_OFFERS:
      return {...state, demand: data.demand, offers: data.offers}
    case FETCHED_SUB_DEMAND_OFFERS:
      return {...state, sub_demand: data.demand, sub_offers: data.offers}
    case FETCHED_MY_ORDERS:
      return {...state,  my_orders: data};
    case FETCHED_MY_UNMATCHED_ORDERS:
      return {...state,  my_unmatched_orders: data};
    case FETCHED_MATCHED_ORDERS:
      return { ...state, matched_orders:data.reverse()}
    case FETCHED_MY_MATCHED_ORDERS:
      // if(state.firstCallDone && data.length != state.my_matched_orders.length){
      //   const cmp = (x,y) => x.maker.txHash == y.maker.txHash && x.maker.txOutputIndex == y.maker.txOutputIndex;
      //   let newTxs = differenceWith(cmp,data,state.my_matched_orders)
      //   for(let tx of newTxs){
      //     // if(tx.isMaker) M.toast({html: `Buy ${tx.maker.receivesToChain.toUpperCase()} for ${tx.maker.sendsFromChain.toUpperCase()} Order Fulfilled`,classes: 'black',displayLength:3000});
      //   }
      // }
      return { ...state, my_matched_orders: data,firstCallDone:true};
    case FETCHED_PAST_ORDERS:
      return {...state,  past_orders: data.reverse()};
    case FETCHED_MY_PAST_ORDERS:
      return { ...state, my_past_orders: data};
    case REMOVE_WALLET:
      return { ...state, my_past_orders:[],my_matched_orders:[],my_orders:[]}
    default:
      return state;
  }
}
